import { sanitizeHTMLContent } from '@lno/core/utils/string/string'

const getSanitizedContent = (content: string) =>
  (sanitizeHTMLContent(content) as string)?.replace(/\n/g, '') || ''

export const utils = { getSanitizedContent }
